import { paperClasses } from '@mui/material/Paper';
import { alpha } from '@mui/material/styles';

import { menuItemClasses } from '@mui/material/MenuItem';
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import { iconButtonClasses } from '@mui/material/IconButton';
import { checkboxClasses } from '@mui/material/Checkbox';
import { listClasses } from '@mui/material/List';
import { gridClasses } from '@mui/x-data-grid';
import { tablePaginationClasses } from '@mui/material/TablePagination';
import { gray } from '../../../shared-theme/themePrimitives';

/* eslint-disable import/prefer-default-export */
export const dataGridCustomizations = {
  MuiDataGrid: {
    styleOverrides: {
      root: ({ theme }) => ({
        '--DataGrid-overlayHeight': '300px',
        /* Фон заголовков как у таблицы (DataGrid задаёт его через CSS-переменную) */
        '--DataGrid-t-header-background-base': 'transparent',
        overflow: 'visible',
        border: 'none',
        backgroundColor: (theme.vars || theme).palette.background.default,
        /* Без фона у заголовков и футера — единый тон с таблицей */
        [`& .${gridClasses.columnHeader}`]: {
          backgroundColor: 'transparent',
        },
        [`& .${gridClasses.footerContainer}`]: {
          backgroundColor: 'transparent',
          borderTop: 'none',
          overflow: 'visible',
          minHeight: 52,
        },
        /* Keep rows-per-page select visible (wide "1–20 of NNNNNN" must not clip it). */
        [`& .${tablePaginationClasses.root}`]: {
          marginRight: theme.spacing(1),
          overflow: 'visible',
          flexWrap: 'wrap',
          '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
            whiteSpace: 'nowrap',
          },
          '& .MuiIconButton-root': {
            maxHeight: 32,
            maxWidth: 32,
            '& > svg': {
              fontSize: '1rem',
            },
          },
        },
        /* v8 Toolbar default is flex: 0 1 1px — wrapped buttons overflow onto rows on mobile */
        [`& .${gridClasses.toolbar}, & .${gridClasses.toolbarContainer}`]: {
          flex: '0 0 auto',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'flex-start',
          minHeight: 'auto',
          height: 'auto',
          rowGap: theme.spacing(0.5),
          borderBottom: 'none',
        },
        [`& .${gridClasses.toolbarDivider}`]: {
          display: 'none',
        },
        /* Убираем линию под строкой заголовков */
        [`& .${gridClasses['row--borderBottom']}`]: {
          borderBottomWidth: 0,
        },
        [`& .${gridClasses['row--borderBottom']} .${gridClasses.columnHeader},
          & .${gridClasses['row--borderBottom']} .${gridClasses.filler},
          & .${gridClasses['row--borderBottom']} .${gridClasses.scrollbarFiller}`]: {
          borderBottomWidth: 0,
        },
        [`& .${gridClasses['row--borderBottom']} .${gridClasses.cell}`]: {
          borderBottomWidth: 0,
        },
        /* Без рамок и разделителей — чище вид */
        [`& .${gridClasses.columnSeparator}`]: {
          display: 'none',
        },
        [`& .${gridClasses['cell--withRightBorder']}, & .${gridClasses['columnHeader--withRightBorder']}`]: {
          borderRightWidth: 0,
        },
        [`& .${gridClasses['cell--withLeftBorder']}, & .${gridClasses['columnHeader--withLeftBorder']}`]: {
          borderLeftWidth: 0,
        },
        [`& .${checkboxClasses.root}`]: {
          padding: theme.spacing(0.5),
          '& > svg': {
            fontSize: '1rem',
          },
        },
      }),
      cell: ({ theme }) => ({
        borderTopColor: 'transparent',
        borderRightColor: 'transparent',
        borderLeftColor: 'transparent',
      }),
      menu: ({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
        backgroundImage: 'none',
        [`& .${paperClasses.root}`]: {
          border: `1px solid ${(theme.vars || theme).palette.divider}`,
        },
        [`& .${menuItemClasses.root}`]: {
          margin: '0 4px',
        },
        [`& .${listItemIconClasses.root}`]: {
          marginRight: 0,
        },
        [`& .${listClasses.root}`]: {
          paddingLeft: 0,
          paddingRight: 0,
        },
      }),
      row: ({ theme }) => ({
        '&:hover': {
          backgroundColor: (theme.vars || theme).palette.action.hover,
        },
        '&.Mui-selected': {
          background: (theme.vars || theme).palette.action.selected,
          '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
          },
        },
      }),
      iconButtonContainer: ({ theme }) => ({
        [`& .${iconButtonClasses.root}`]: {
          border: 'none',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: alpha(theme.palette.action.selected, 0.3),
          },
          '&:active': {
            backgroundColor: gray[200],
          },
          ...theme.applyStyles('dark', {
            color: gray[50],
            '&:hover': {
              backgroundColor: gray[800],
            },
            '&:active': {
              backgroundColor: gray[900],
            },
          }),
        },
      }),
      menuIconButton: ({ theme }) => ({
        border: 'none',
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: gray[100],
        },
        '&:active': {
          backgroundColor: gray[200],
        },
        ...theme.applyStyles('dark', {
          color: gray[50],
          '&:hover': {
            backgroundColor: gray[800],
          },
          '&:active': {
            backgroundColor: gray[900],
          },
        }),
      }),
      filterForm: ({ theme }) => ({
        gap: theme.spacing(1),
        alignItems: 'flex-end',
      }),
      columnsManagementHeader: ({ theme }) => ({
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
      }),
      columnHeaderTitleContainer: {
        flexGrow: 1,
        justifyContent: 'space-between',
      },
      columnHeaderDraggableContainer: { paddingRight: 2 },
    },
  },
};
